import { cloneDeep } from '@apollo/client/utilities';
import { forCreate, forDelete, forUpdate, EntityInput } from '../common/entity';
import { CompanyRole, CompanyRoleAssignment } from './companyRoleAssignment';
import { CustomField, CustomFieldEntityType, WithCustomFields } from '../custom_field/customField';

export class CompanyRoleAssignmentInput extends CompanyRoleAssignment implements EntityInput<CompanyRoleAssignment> {
  forCreate() {
    return CreateCompanyRoleAssignmentInput.from(
      {
        ...this,
        customFields: this.customFieldValues(),
      },
      CreateCompanyRoleAssignmentInput,
    );
  }

  forUpdate() {
    return UpdateCompanyRoleAssignmentInput.from(
      {
        ...this,
        customFields: this.customFieldValues(),
      },
      UpdateCompanyRoleAssignmentInput,
    );
  }

  forDelete() {
    return DeleteCompanyRoleAssignmentInput.from(this, DeleteCompanyRoleAssignmentInput);
  }

  withRole(role: CompanyRole) {
    this.role = role;
    return cloneDeep(this);
  }

  withEmail(email: string) {
    this.email = email;
    return cloneDeep(this);
  }

  hasChanges(original?: CompanyRoleAssignment) {
    if (!original) return true;

    if (this.role !== original?.role) return true;
    if (this.email !== original?.email) return true;

    return !WithCustomFields.equal(original?.customFieldValues(), this.customFieldValues());
  }

  validate(customFields: Map<string, CustomField>) {
    const mandatoryCustomFields = [...customFields.values()].filter(
      cf => cf.entityType === CustomFieldEntityType.companyRole && cf.mandatory && !cf.hidden && !cf.generated,
    );
    if (mandatoryCustomFields.some(cf => !this.customFields.get(cf.id)?.value)) return false;

    return true;
  }
}

export class CreateCompanyRoleAssignmentInput extends forCreate(CompanyRoleAssignment) {}

export class UpdateCompanyRoleAssignmentInput extends forUpdate(CompanyRoleAssignment) {}

export class DeleteCompanyRoleAssignmentInput extends forDelete(CompanyRoleAssignment) {}
